module.exports = __webpack_public_path__ + "img/kv.d6cee5f.jpg";